module.exports = __webpack_public_path__ + "static/media/bg1.784b7253.jpg";